export enum TabNames {
  Favorites = "Favorites",
  Recent = "Recent",
  Trending = "Trending"
}

export type TabValue = {
  name: string;
  learnerUid: string | null;
};
